import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterNewformComponent } from './master-newform.component';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { TitleCasePipe } from '@angular/common';
import { MasterNewformRoutingModule } from './master-newform-routing.module';
import { CustomRadioButtonModule } from 'src/app/shared/components/custom-radio-button/custom-radio-button.module';
import { PortRequestFormRoutingModule } from '../port-request-form/port-request-form-routing.module';
import { ForceApprovePopupModule } from 'src/app/shared/components/force-approve-popup/force-approve-popup.module';
import { PreviousVesselSummaryModule } from './previous-vessel-summary-routing/previous-vessel-summary.module';
import { ViewDraftEmailPopupModule } from 'src/app/shared/components/view-draft-email-popup/view-draft-email-popup.module';


@NgModule({
  declarations: [
    MasterNewformComponent
  ],
  imports: [
    CommonModule,
    CustomInputModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    ExpansionPanelModule,
    CustomDatePickerModule,
    MaterialModule,
    ForceApprovePopupModule,
    ViewDraftEmailPopupModule,
    MatPaginatorModule,
    CustomTimpickerModule,
    MatSortModule,
    MasterNewformRoutingModule,
    CustomRadioButtonModule,
    PortRequestFormRoutingModule,
    PreviousVesselSummaryModule
  ],
 
})
export class MasterNewformModule { }
